import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Tooltip } from "@mui/material";
import { messages } from "./constants";
import { TooltipProps } from "../../../helpers/materialUITheme";
import { getTooltipByStatus } from "./helpers";

export const ObjectStatusCell = ({ item }) => {
  const { t } = useTranslation();

  const status = useMemo(() => messages?.find((mess) => mess?.status === item?.status), [item]);
  if (!status) return;
  const statusName = t(`label:objectStatusTooltips:${status?.message}`);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Tooltip title={getTooltipByStatus(item, status, statusName)} componentsProps={TooltipProps}>
        <img src={status.iconSrc} alt="Иконка статуса объекта" />
      </Tooltip>
    </Box>
  );
};
